import { render, staticRenderFns } from "./ColorPropertyItem.vue?vue&type=template&id=c8d0f4da&scoped=true"
import script from "./ColorPropertyItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColorPropertyItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ColorPropertyItem.vue?vue&type=style&index=0&id=c8d0f4da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d0f4da",
  null
  
)

export default component.exports